const fr = {
    application_title: 'Login',
    japanese: 'Japonais',
    english: 'Anglais',
    french: 'Français ',
    german: 'Allemand',
    italian: 'Italien',
    spanish: 'Espagnol',
    language: 'Langue',
    login_selectscreen: 'Sélectionner l\'écran',
    login_all: 'tous',
    login_executive: 'Exécutif',
    login_manager: 'Manager',
    login_operator: 'Opérateur',
    login_forgot_password: 'Vous avez oublié votre mot de passe',
    user_id: 'Nom de l\'utilisateur',
    user_password: 'mot de passe',
    authorizer: 'Autorisateur ',
    authorizer_text: 'Note : Veuillez entrer l\'adresse e-mail de l\'auteur. L\'auteur doit être un employé de Konica Minolta (un utilisateur avec un domaine konica minolta).',
    sign_in: 's\'inscrire sur',
    sign_in_error: 'Nom d\'utilisateur ou mot de passe erroné',
    create_account: 'Créer un nouveau compte',
    forget_password_title: 'Veuillez envoyer une demande de réinitialisation du mot de passe à l\'adresse électronique ci-dessous.',
    forget_password_email: 'dashboard-u_support2@gcp.konicaminolta.com',
    forget_password_text: 'Veuillez copier le texte ci-dessous, le coller dans la ligne d\'objet et l\'envoyer par e-mail.\n\
    >[Request] Réinitialisation du mot de passe\n・Vous pouvez laisser le message principal de l\'e-mail vide.\n\
・Veuillez envoyer l\'e-mail depuis l\'adresse e-mail enregistrée dans ce logiciel.\n\
・Il se peut que nous ne soyons pas en mesure de répondre aux demandes provenant d\'adresses e-mail non enregistrées.\n\
・Si vous ne recevez pas de réponse dans les 24 heures ouvrables, veuillez nous la renvoyer.\n\
・Veuillez noter que votre compte sera supprimé si vous ne confirmez pas votre connexion dans le mois suivant la réception de cet e-mail.\n\
・Veuillez confirmer la notification du nouveau mot de passe à l\'adresse e-mail suivante.\n\
"no-reply@verificationemail.com"',
    forget_password_team: 'Équipe de l\'opération ultime du tableau de bord AccurioPro',
    privacy_statement: 'Déclaration de confidentialité',
    privacy_statement_contents: 'Chez Konica Minolta Business Solutions Europe GmbH et ses filiales, sociétés sœurs et sociétés mères dont la liste figure en annexe 1. ("Konica Minolta"), nous prenons la question de la confidentialité au sérieux. Cette politique de confidentialité fournit des informations sur la manière dont nous collectons, utilisons, divulguons et gérons les données personnelles. \n\n\
Qui est le contrôleur des données ? \n\
Konica Minolta utilisera vos données personnelles mentionnées ci-dessous. \n\n\
Quelles sont les informations que nous recueillons à votre sujet ? \n\
Konica Minolta recueille votre adresse e-mail. \n\
Comment vos informations seront-elles utilisées ? \n\
Konica Minolta utilise vos informations ci-dessus uniquement dans le but indiqué ci-dessous : \n\
Identification et ; \n\
contact pour fournir les informations nécessaires sur AccurioPro Dashboard. \n\
Quelle est notre base légale pour le traitement de vos données personnelles ? \n\
\'intérêt légitime est la base légale du traitement. \n\
Les intérêts légitimes sont a) \'identification, et b) le contact pour fournir les informations nécessaires sur AccurioPro Dashboard. \n\
Qui reçoit vos informations ? \n\
Vos données personnelles ci-dessus seront traitées de manière strictement confidentielle, et ne seront pas partagées avec un tiers sans votre consentement préalable. \n\n\
Période de stockage \n\
Konica Minolta traitera les données personnelles pendant la durée de votre besoin d\'utiliser AccurioPro Dashboard pour votre mission et continuera à stocker uniquement les données personnelles nécessaires pendant trois mois après le changement de votre mission ou votre départ de l\'entreprise ("Changement"). Au cours de la période de suppression allant du changement jusqu\'à trois mois après le changement, toute donnée personnelle non nécessaire sera supprimée car Konica Minolta supprime les données personnelles qui ne sont pas nécessaires par trimestre. \n\n\
Stockage des données et transfert des données \n\
Les données sont stockées en Allemagne. Pour l\'identification et le contact, Konica Minolta, Inc. est impliqué .  Le Japon est un pays qui assure un niveau adéquat de protection des données personnelles décidé par la Commission européenne. \n\n\
Quels sont vos droits dans le cadre du GDPR ? \n\
Lorsque Konica Minolta est en possession ou traite vos données personnelles, vous disposez des droits suivants : \n\
Droit d\'accès - vous avez le droit de demander une copie des informations que nous détenons à votre sujet. \n\
Droit de rectification - vous avez le droit de corriger les données que nous détenons à votre sujet qui sont inexactes ou incomplètes. \n\
Droit à l\'oubli - dans certaines circonstances, vous pouvez demander que les données que nous détenons sur vous soient effacées de nos dossiers. \n\
Droit à la restriction du traitement - lorsque certaines conditions s\'appliquent, vous avez le droit de restreindre le traitement. \n\
Droit à la portabilité - vous avez le droit de faire transférer les données que nous détenons sur vous à une autre organisation. \n\
Droit d\'opposition - vous avez le droit de vous opposer à certains types de traitement tels que le marketing direct. \n\
Droit d\'opposition au traitement automatisé, y compris le profilage - vous avez également le droit d\'être soumis aux effets juridiques du traitement automatisé ou du profilage. \n\
Si Konica Minolta refuse votre demande en vertu des droits d\'accès, nous vous fournirons une explication raisonnable. \n\
Si vous exercez l\'un de vos droits, veuillez envoyer un e-mail à dashboard-u_support1@gcp.konicaminolta.com. \n\n\
Coordonnées du responsable du traitement des données \n\
Nous vous invitons à contacter notre société à tout moment si vous avez des questions relatives au sujet de la confidentialité des données. Les coordonnées d\'autres sociétés sont mentionnées dans l\'annexe 2.\n\
Konica Minolta Business Solutions Europe GmbH \n\
Europaallee 17 \n\
30855 Langenhagen \n\
Allemagne Téléphone : +49 (0)511 7404-0 \n\
E-Mail : dataprotection(at)konicaminolta.eu \n\
Pièce jointe.1 \n\
Konica Minolta Business Solutions Deutschland GmbH, \n\
Konica Minolta Business Solutions France S.A.S., \n\
Konica Minolta Business Solutions (UK) Limited, \n\
Konica Minolta Business Solutions Romania s.r.l., \n\
Konica Minolta Business Solutions Italia S.p.A., \n\
Konica Minolta Business Solutions Nederland B.V., \n\
Konica Minolta Business Solutions Greece S.A., FR \n\
Konica Minolta Business Solutions Czech spol. s r.o., \n\
Konica Minolta Hungary Business Solutions S.A., Tél. \n\
Konica Minolta Business Solutions Polska Sp.z.o.o., Tél. \n\
Konica Minolta Business Solutions Bulgaria EOOD, FR \n\
Konica Minolta Business Solutions Slovenia d.o.o., FR \n\
Konica Minolta Croatia-Business Solutions d.o.o., Tél. \n\
Konica Minolta Slovakia spol. s.r.o., Tél. \n\
Konica Minolta Baltia UAB, Tél. \n\
Konica Minolta Business Solutions Denmark A/S, \n\
Konica Minolta Business Solutions Spain S.A., \n\
Konica Minolta Business Solutions Sweden AB, FR \n\
Konica Minolta Business Solutions Norway AS, \n\
Konica Minolta Business Solutions (Belgique) N.V., \n\
Konica Minolta Business Solutions Austria GmbH, FR \n\
Konica Minolta Business Solutions Portugal, Unipessoal Lda, Tél. \n\
Konica Minolta Business Solutions Finland Oy, et \n\
Konica Minolta, Inc. dont le siège social est situé 2-7-2, Marunouchi, Chiyoda-ku, Tokyo, Japon. \n\
Pièce jointe.2 \n\
Konica Minolta Business Solutions Deutschland GmbH \n\
Europaallee 17, 30855 Langenhagen, Allemagne. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions France S.A.S. \n\
365-367 Route de Saint-Germain, F-78424 Carrieres-sur-Seine, France. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions (Royaume-Uni) Limited \n\
Miles Gray Road, Basildon, Essex, SS14 3AR, Royaume-Uni. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Romania s.r.l. \n\
Str. Copilului nr. 18, parter, sector 1, 012178 Bucarest, Roumanie. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Italia S.p.A. \n\
Viale Certosa, 144, 20156 Milano, Italie. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Nederland B.V. \n\
Hoogoorddreef 9, Postbus 22110, 1100 CC Amsterdam, Pays-Bas. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Grèce S.A. \n\
3, Messologiou Str., GR-14451 Metamorphosis, Athènes, Grèce \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Czech spol. s r.o. \n\
Brno - Židenice, Žarošická 4395/13, PSČ 628 00, République tchèque \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Hungary Business Solutions Ltd. \n\
Galvani u. 4., 1117 Budapest, Hongrie \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Polska Sp.z.o.o. \n\
Muszkieterów 15, 02-273 Warszawa, Pologne. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Bulgaria EOOD \n\
Biznes park Sofia 7, 1715 Sofia, Bulgarie \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Slovénie d.o.o. \n\
Vodovodna cesta 101, 1000 Ljubljana, Slovénie \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Croatia-Business Solutions d.o.o. \n\
Radnicka cesta 1a, HR-10000 Zagreb, Croatie \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Slovakia spol. s.r.o. \n\
Cernysevskeho 10, 85101 Bratislava, République slovaque \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Baltia UAB \n\
J. Jasinskio str. 16, LT2001 Vilnius, Lituanie \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Danemark A/S \n\
Lautrupvang 2B, 2750 Ballerup, Danemark \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Espagne S.A. \n\
C/ Albasanz, 12, 28037 Madrid, Espagne. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Sweden AB \n\
Kronborgsgränd 19, S-164 46 Kista, Suède ou Boîte postale 1125, S-164 22 Kista, Suède. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Norvège AS \n\
Maridalsveien 323, 0872 Oslo, Norvège \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions (Belgique) N.V. \n\
Excelsiorlaan 10, 1930 Zaventem, Belgique. \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Austria GmbH \n\
Amalienstrasse 59-61, A-1131 Vienna, Autriche \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Portugal, Unipessoal Lda. \n\
Rua Professor Henrique de Barros nº 4, 10º B 2685-338 Prior Velho, Portugal \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta Business Solutions Finland Oy \n\
Keilaranta 10 E, 02150 Espoo, Finlande \n\
dashboard-u_support1@gcp.konicaminolta.com \n\
Konica Minolta, Inc. \n\
2-7-2 Marunouchi, Chiyoda-ku, Tokyo, \n\
Japon \n\
dashboard-u_support1@gcp.konicaminolta.com',
    register: 'Registre',
    update: 'Update',
    email: 'l\'adresse e-mail',
    fields_compulsory: 'Tous les champs sont obligatoires',
    authorizer_email_error: 'Adresse e-mail de l\'auteur non valide.',
    email_error: 'Adresse électronique non valide.',
    username_error: 'Seuls des caractères alphanumériques peuvent être saisis pour le nom d\'utilisateur.',
    serial_number_duplicate_error: 'Les numéros de série sont dupliqués.',
    password_match_error: 'Les mots de passe ne correspondent pas',
    not_km_domain: 'Le domaine de l\'adresse e-mail de l\'auteur n\'est pas le domaine de konicaminolta',
    registered: 'Enregistré !',
    add_account_email_text: 'Cher {authorizer},%0D%0A%0D%0A\n{email} vous avez créé votre compte Printer Performance Analysis tool.%0D%0A%0D%0A\n\n\
Toute personne qui n\'est pas membre de Konica Minolta peut utiliser cette application avec l\'approbation d\'un utilisateur Konica Minolta.%0D%0A\n\
Veuillez donc vous connecter à l\'URL ci-dessous et l\'approuver.%0D%0A%0D%0A\n\
URL %0D%0A\n\
{url} %0D%0A%0D%0A\n\n\
Cordialement, %0D%0A\n\Nous vous remercions.%0D%0A\n\
Konica Minolta Inc. %0D%0A\n\n\
',
    customer_email_text: 'Cher {email},%0D%0A%0D%0A\
Nous avons créé votre compte pour Printer Performance Analysis tool.%0D%0APrenez soin de vous connecter à l\'URL ci-dessous.%0D%0A\
URL: https://dashboard-u.konicaminolta.com%0D%0A\
nom d\'utilisateur : {userId}%0D%0A\
password: {password}%0D%0A%0D%0A\
Vous pouvez utiliser toutes les fonctions de cette application après avoir entré le PKID dans la fonction de réglage de la licence.%0D%0A\
*Le PKID vous sera envoyé séparément par e-mail. Veuillez vous en assurer.%0D%0A%0D%0A\
Cordialement, %0D%0AKonica Minolta Inc.',
    request_to_you: 'Demande à vous',
    http_get_error: '{status} : Le traitement a échoué. Retournez à l\'écran de connexion.',
    server_error: 'Erreur de serveur interne.',
    http_connection_error: 'Non connecté à l\'internet.',
    ce_top_title: 'Sélectionnez le client auquel vous voulez vous connecter.',
    add_customers_account: 'Ajouter le compte du client',
    go_back: 'Dos',
    customers: 'Vos clients',
    serial_numbers: 'Numéros de série enregistrés',
    open: 'Aprire',
    add_sn: 'Ajouter le numéro de série de l\'imprimante',
    add_ce: 'Ajouter CE pour suivre ce client',
    printers_sn: 'Numéro de série de l\'imprimante',
    edit_customer_title: 'Modifier l\'enregistrement des clients',
    customer_email_address: 'Adresse électronique du client',
    license: 'Licence',
    printers_registered: 'Imprimantes enregistrées',
    serial_number: 'Numéro de série',
    latest_data: 'Dernières données',
    persons_in_charge: 'Personnes responsables',
    customer_engineer: 'Ingénieur client',
    sender: 'de',
    authorization: 'Autorisation',
    approve: 'approuver',
    do_not_approve: 'Ne pas approuver',
    request_approved: 'Demande approuvée !',
    request_disapproved: 'Demande non approuvée !',
    approved: 'Approuvé',
    do_not_approved: 'Rejeté',
    processed_result: 'Résultat traité',
    processed_date: 'Date de traitement',
    header_nfr: 'Licence non destinée à la revente (NFR)',
    header_recommendation: 'Recommandation',
    header_previous: 'précédent',
    header_next: 'prochain',
    header_reset: 'réinitialiser',
    header_change_password: 'Modifier le mot de passe',
    header_settingMenu_tutorial: 'Tutoriels',
    header_old_password: 'Mot de passe actuel',
    header_new_password: 'Nouveau mot de passe',
    header_confirm_password: 'Nouveau mot de passe (Confirmer)',
    header_cancel: 'Annuler',
    header_apply: 'appliquer',
    header_ok: 'OK',
    header_close: 'fermer',
    from: 'de',
    to: 'à',
    change_date_heading: 'Réglage de l\'intervalle',
    change_date_explanation: 'Veuillez sélectionner la période d\'exportation du CSV.',
    header_password_explanation: 'Veuillez créer un mot de passe avec une chaîne de 8 caractères ou plus comprenant des lettres majuscules et minuscules et des chiffres.',
    header_machine_setting: 'Réglage de la machine',
    header_machine_setting_title: 'Réglage de la machine',
    header_machine_setting_notes: 'Réglage de la machine',
    header_machine_setting_model: 'Modèle',
    header_machine_setting_serial_number: 'S/N：',
    header_machine_setting_machine_name: 'Nom de la machine',
    header_machine_setting_error_message_max_length: 'Veuillez saisir 64 caractères ou moins.',
    header_machine_setting_error_message_min_length: 'Veuillez saisir le nom de la machine.',
    header_machine_setting_error_message_common: 'Veuillez vérifier le contenu du nom de la machine.',
    header_machine_setting_complete_message: 'La mise à jour est terminée. Rechargez l\'écran.',
    header_lms_setting: 'Paramétrage de la licence',
    header_lms_explanation: 'Entrez la Clé de produit notifiée par email, appuyez sur le bouton "référer", puis appuyez sur le bouton "activer".',
    header_lms_add: 'Ajouter',
    header_lms_delete: 'Supprimer',
    header_lms_pkIdTitle: 'Product Key',
    header_lms_refer: 'se référer à',
    header_lms_licenseKind: 'type de licence',
    header_lms_licenseDate: 'la licence a expiré',
    header_lms_licenseState: 'activer l\'état',
    header_lms_activate: 'activer',
    header_lms_deactivate: 'désactiver',
    header_lms_state_activate: 'activer',
    header_lms_state_deactivate: 'désactiver',
    header_lms_ptl_date: 'La licence de test expirera le',
    header_lms_activationDate: 'Activation disponible',
    header_lms_never_expired: 'Jamais expiré',
    header_users_guide: 'Guide de l\'utilisateur',
    header_users_guide_link: 'https://www.btapac.konicaminolta.com/users_guide/accuriopress_C14000_series/3_0_0/en/index.html',
    header_version_info: 'Version',
    screen1_productivity_rate: 'Taux de productivité',
    screen1_productivity_pred: 'Prévision de la productivité',
    screen1_week_before_last_availability: 'Avant-dernière semaine',
    screen1_productivity_diff: 'Différence réelle',
    screen1_week_before_last_pred_diff: 'Différence entre les prévisions et les réalisations de la semaine précédente',
    screen1_productivity_a4_tips: 'La productivité est convertie au format A4',
    screen1_productivity_a3_tips: 'La productivité est convertie au format A3',
    screen1_results_of_production: 'Résultats de la production',
    screen1_est_print_time: 'Temps d\'impression prévu (hh:mm)',
    screen1_act_print_time: 'Temps d\'impression réel (hh:mm)',
    screen1_gap: 'Écart (hh:mm)',
    screen1_sheets: 'nombre d\'impressions',
    screen1_sheets_per_h: 'nombre d\'impressions/heure',
    screen1_availability: 'Taux de réalisation (%)',
    screen1_job_list_link: 'Liste des commandes',
    screen1_machine_list_link: 'Liste des machines',
    top_manager_title_production_result: 'Total',
    top_manager_title_prints: 'Imprimés',
    top_manager_title_errors: 'erreurs',
    top_manager_jobs: 'travaux d\'impression',
    top_manager_color_pv: 'pages de couleur',
    top_manager_bw_pv: 'Pages en noir et blanc',
    top_manager_output_paper: 'Pages imprimées',
    top_manager_trayfull_count: 'bac de sortie plein',
    top_manager_paperjams__count: 'Bourrages papier',
    top_manager_servicecall_count: 'appel de service',
    top_manager_paperempty_count: 'Magasin de papier vide',
    top_manager_tonerempty_count: 'Toner vide',
    top_operator_title_production_result: 'Résultats de l\'opération de l\'unité',
    top_operator_title_trouble_result: 'Total',
    top_operator_subtitle_output_paper_result: 'Tendance sur le nombre de pages produites',
    top_operator_subtitle_output_availability_result: 'résultats des opérations',
    top_operator_paper_count: 'Nombre de papier en sortie',
    top_operator_subtitle_output_paper_count: 'Nombre de papier en sortie',
    top_operator_subtitle_interruption_result: 'Résultats des interruptions (min)',
    top_operator_trayfull: 'bac de sortie plein',
    top_operator_paperempty: 'Magasin de papier vide',
    top_operator_tonerempty: 'Toner vide',
    top_operator_paperjams: 'Bourrages papier',
    top_operator_servicecall: 'appel de service',
    top_operator_explanation_worst1: 'Facteur d\'arrêt le plus défavorable ',
    top_operator_explanation_worst2: '2ème ',
    top_operator_explanation_worst3: '3ème ',
    screen3_print_hours: 'heures',
    listofprintjobs_title: 'Liste des commandes',
    listofprintjobs_number: 'No.',
    listofprintjobs_start_time: 'Heure de début',
    listofprintjobs_job_id: 'numéro de commande',
    listofprintjobs_pages_set: 'pages/<br>sets',
    listofprintjobs_output_set: 'sets<br>de sortie',
    listofprintjobs_exit_count: 'Nombre de papier en sortie',
    listofprintjobs_machine_name: 'système d\'impression',
    jobdetail_left_title: 'détails du poste',
    jobdetail_timeline_title: 'Calendrier de sortie',
    jobdetail_job_id: 'numéro de commande ',
    jobdetail_size: 'format du papier',
    jobdetail_paper_kind: 'type de papier',
    jobdetail_paper_weight: 'grammage du papier/Epaisseur',
    jobdetail_color: 'Mono/Color',
    jobdetail_side: 'simple face / double face',
    jobdetail_pages: 'pages/sets',
    jobdetail_unit_pages: 'Pages',
    jobdetail_units: 'sets de sortie',
    jobdetail_unit_units: 'nombre de sets',
    jobdetail_sheets: 'Nombre de papier en sortie',
    jobdetail_unit_sheets: 'fogli',
    jobdetail_center_title: 'système d\'impression',
    jobdetail_machine_name: 'Nom de la machine',
    jobdetail_tray_full: 'bac de sortie plein',
    jobdetail_paper_empty: 'Magasin de papier vide',
    jobdetail_toner_empty: 'Toner vide',
    jobdetail_paper_jam: 'Bourrages papier',
    jobdetail_service_call: 'appel de service',
    jobdetail_panel_operation: 'Panneau de commande',
    jobdetail_frontdoor_open: 'Porte du système',
    jobdetail_tray_open: 'Magasin de papier',
    jobdetail_right_title: 'Différence entre le temps d\'impression prévu et le temps d\'impression réel',
    jobdetail_graph_x_title: 'Heure d\'impression prévue (hh:mm)',
    jobdetail_graph_y_title: 'Temps d\'impression réel',
    jobdetail_legend_jobs: 'Sortie du travail dans {machineName}',
    jobdetail_legend_target: 'Ce travail d\'impression',
    jobdetail_tooltip_jobid: 'numéro de commande:',
    jobdetail_tooltip_diff: 'Différence : ',
    jobdetail_tooltip_actual: 'Temps d\'impression réel : ',
    jobdetail_tooltip_assumed: 'Temps d\'impression supposé :',
    jobdetail_start_time: 'heure de départ',
    jobdetail_end_time: 'heure de fin',
    availabilitydetail_left_title: 'Liste des machines',
    availabilitydetail_center_title: 'Différence entre les machines',
    availabilitydetail_right_title: 'Tendance du temps d\'impression par machine',
    availabilibydetail_unit_hour: 'heures',
    availabilibydetail_machine: 'Machine',
    availabilibydetail_unit_idle: 'Inactif',
    availabilibydetail_unit_interruption: 'Interruption de l\'impression',
    availabilibydetail_unit_preparation: 'Préparation de l\'impression',
    availabilibydetail_unit_printing: 'est en train d\'imprimer',
    joblist_title: 'Liste des commandes',
    joblist_number: 'No.',
    joblist_estprinttime: 'Temps d\'impression prévu (hh:mm)',
    joblist_actprinttime: 'heure réelle d\'impression (hh:mm)',
    joblist_hourlyunits: 'Production horaire en pages',
    joblist_printcompletedtime: 'Heure d\'impression (hh:mm)',
    joblist_printtimediff: 'Gap (hh:mm)',
    joblist_csv_export: 'Exportation CSV',
    joblist_est_hourlyunits: 'Prévisions de pages par heure',
    joblist_est_printcompletedtime: 'Temps d\'impression prévu (hh:mm)',
    joblist_act_hourlyunits: 'Pages réelles par heure',
    joblist_act_printcompletedtime: 'Temps d\'impression réel',
    proddetail_title: 'Écart de prédiction du temps d\'impression',
    proddetail_table_title: 'Tendances des volumes de production',
    proddetail_graph_yaxis_left: 'Heure d\'impression (hh:mm)',
    proddetail_graph_yaxis_right: 'Taux de réalisation (%)',
    proddetail_est_print_time: 'Temps d\'impression prévu',
    proddetail_act_print_time: 'Temps d\'impression réel',
    proddetail_gap: 'Écart (hh:mm)',
    proddetail_duration_daily: 'quotidien',
    proddetail_duration_weekly: 'hebdomadaire',
    proddetail_duration_monthly: 'mensuel',
    machinedetail_left_title: 'Détails de la machine',
    machinedetail_center_title: 'erreurs',
    machinedetail_right_title: 'Détails de la machine disponible',
    machinedetail_availability: 'disponibilité',
    machinedetail_operating_time: 'Durée d\'utilisation (heures)',
    machinedetail_printing_time: 'Temps d\'impression (heures)',
    machinedetail_output_set: 'sets de sortie',
    machinedetail_output_paper: 'Nombre de papier en sortie',
    machinedetail_power_on: 'Mise sous tension',
    machinedetail_power_off: 'Arrêt de l\'alimentation',
    common_min_per_week: 'min/semaine',
    common_2days_ago: 'avant-hier',
    common_yesterday: 'hier',
    common_today: 'Aujourd\'hui',
    common_tomorrow: 'demain',
    common_2days_after: 'après-demain',
    common_2weeks_ago: 'il y a 2 semaines',
    common_last_week: 'La semaine dernière',
    common_this_week: 'cette semaine',
    common_next_week: 'semaine prochaine',
    common_2weeks_after: 'la semaine prochaine',
    common_2months_ago: 'il y a 2 mois',
    common_last_month: 'le mois dernier',
    common_this_month: 'ce mois-ci',
    common_next_month: 'le mois prochain',
    common_2months_after: 'mois suivant le mois suivant',
    common_days_ago: 'Il y a {dateNum} jours',
    common_weeks_ago: 'il y a {dateNum} mois',
    common_months_ago: 'il y a {dateNum} mois',
    common_days_after: '{dateNum} jours après',
    common_weeks_after: '{dateNum} semaines après',
    common_months_after: '{dateNum} mois après',
    common_mins: 'minutes',
    common_hours: 'heures',
    common_date: 'Date',
    common_percentage: '%',
    icon_recommendation: 'Recommandation',
    icon_analysis: 'Analyse',
    icon_operation: 'Opération',
    icon_machine: 'Machine',
    icon_material: 'Matériau',
    icon_method: 'Méthode',
    icon_running_time: 'temps de fonctionnement',
    icon_preparation_time: 'Préparation de l\'impression',
    icon_downtime: 'Interruption de l\'impression',
    paperEmpty: 'papier vide',
    tonerEmpty: 'toner vide',
    trayFull: 'Cassette de papier pleine',
    Total: 'Total',
    Average: 'AVE.',
    hour_unit: 'heures',
    date_format: 'DD.MM.YY',
    date_format2: 'DD.MM',
    month_format: 'MM.YY',
    errCode_10000: 'Le changement de mot de passe a échoué.',
    errCode_10001: 'Le nouveau mot de passe et le nouveau mot de passe (confirmation) ne correspondent pas.',
    errCode_10002: 'Le mot de passe doit être une chaîne de caractères d\'au moins 8 caractères comprenant des lettres majuscules et minuscules et des chiffres.',
    errCode_10003: 'Veuillez attendre environ 10 minutes, puis changez à nouveau votre mot de passe.',
    errCode_10004: 'Le mot de passe actuel est incorrect.',
    errCode_10005: 'Votre session a expiré. Veuillez vous reconnecter.',
    errCode_10006: 'Une erreur de réseau s\'est produite.',
    errCode_10100: 'Une erreur s\'est produite. Veuillez contacter l\'administrateur.',
    errCode_10101: 'Veuillez entrer la clé du produit.',
    errCode_10102: 'Impossible d\'obtenir l\'information sur la clé de produit.',
    errCode_10103: 'L\'activation a échoué.',
    errCode_10104: 'La désactivation a échoué.',
    errCode_10105: 'Échec de la suppression des informations sur la clé de produit.',
    errCode_10106: 'Impossible de définir la même clé de produit.',
    errCode_10007: 'Veuillez vérifier le courriel de vérification et vous connecter à partir du lien contenu dans le corps du courriel.',
    errCode_20000: 'Le paramètre est invalide.',
    errCode_20001: 'L\'adresse mail spécifiée existe déjà.',
    errCode_20002: 'Le nom d\'utilisateur spécifié existe déjà. Veuillez spécifier un autre nom d\'utilisateur.',
    errCode_20003: 'Le nom d\'utilisateur spécifié n\'est pas enregistré en tant que client.',
    suggestion_overview: 'Vue d\'ensemble',
    suggestion_pgap_overview_good: 'L\'écart de prédiction a diminué',
    suggestion_pgap_overview_bad: 'L\'écart de prédiction a augmenté',
    suggestion_pgap_overview_even: 'L\'écart de prédiction n\'a pas changé',
    suggestion_ma_overview_good: 'Le taux de disponibilité a augmenté',
    suggestion_ma_overview_bad: 'Le taux de disponibilité a diminué',
    suggestion_ma_overview_even: 'Le taux de disponibilité n\'a pas changé',
    suggestion_attention_machine: 'la machine requiert de l\'attention: ',
    suggestion_tips: 'Conseils',
    suggestion_pv_up: 'Augmentation du volume d\'impression',
    suggestion_pv_down: 'Le volume d\'impression a diminué',
    suggestion_pv_even: 'Le volume d\'impression n\'a pas changé',
    suggestion_downtime_long: 'Augmentation des temps d\'arrêt',
    suggestion_smalljob_many: 'Augmentation des emplois dans les petits lots',
    suggestion_efficiency_up: 'L\'efficacité de la production a augmenté',
    ce_login_tutorial: 'Pour le déploiement, consultez le tutoriel',
    ce_dialog_header_confirm: 'Confirmation',
    ce_confirmation_message: 'Voulez-vous vraiment mettre à jour les détails du client ?',
    ce_email_confirmation: 'L\'email d\'initialisation du mot de passe du client sera créé. Vous êtes sûr ?',
    username_email: 'Nom d\'utilisateur (adresse e-mail)',
    ce_dialog_header_info: 'Information',
    ce_account_complete_kmce: 'L\'enregistrement du compte a été effectué. Allez à l\'écran de connexion.',
    ce_account_complete_dealer: 'La demande d\'enregistrement du compte a été complétée. Veuillez attendre l\'approbation.',
    ce_user_account_complete_kmce: 'L\'enregistrement du compte est terminé.',
    ce_user_account_complete_dealer: 'La demande d\'enregistrement du compte a été complétée. Veuillez attendre l\'approbation.',
    ce_error_400: 'Une erreur s\'est produite. Veuillez vérifier le contenu.',
    ce_error_409: 'Récupérer des informations parce qu\'elles ont été mises à jour par un autre utilisateur.',
    ce_top_operator_user_name: 'L\'écran de l\'opérateur principal de {userName}.',
    add_new_customer: 'Ajouter un nouveau client',
    add_existed_customer: 'Ajouter un client existant',
    ce_edit_licenseExpiresOn: 'Expire le',
    send_mail: 'Envoi du courrier réussi.',
    password_change_complete: 'Le changement de mot de passe est terminé.',
    reset_password: 'Réinitialisation du mot de passe',
    change_button: 'changement',
    send_button: 'envoyer',
    common_error_500: 'Échec du traitement.',
    error_send_mail: 'Échec de l\'envoi du courrier.',
    error_confirm_password_incorrect: 'Le mot de passe et le mot de passe de confirmation sont différents.',
    error_usename_not_exist: 'Le nom d\'utilisateur spécifié n\'existe pas.',
    error_id_not_exist: 'L\'id spécifié n\'existe pas.',
    error_id_mailaddress_not_exist: 'L\'identifiant ou l\'adresse e-mail spécifié(e) n\'existe pas.',
    ce_forget_password_dialog_message: 'Envoyez un courriel de changement de mot de passe. Veuillez changer votre mot de passe à partir de l\'URL décrite dans le corps du courriel.',
    user_forget_password_dialog_message: 'Veuillez confirmer à nouveau si vous souhaitez le modifier, car cela concerne tous les membres qui utilisent ce compte. Un e-mail contenant le nouveau mot de passe vous sera envoyé. Veuillez vous connecter avec le mot de passe indiqué dans l\'e-mail. Si vous ne connaissez pas votre adresse e-mail, veuillez contacter le CE concerné.',
    Mon: 'Lun',
    Tue: 'Mar',
    Wed: 'Mer',
    Thu: 'Jeu',
    Fri: 'Ven',
    Sat: 'Sam',
    Sun: 'Dim',
    header_pending_verification: 'En attente de vérification',
    pending_verification_dialog_message: 'Le compte est verrouillé parce que le compte n\'est pas utilisé pendant longtemps. Avez-vous besoin d\'envoyer un e-mail de confirmation ?',
    trial_license_expired_message: 'La licence d\'essai a expiré. Veuillez saisir la clé du produit',
    errCode_20004: 'URL non valide',
    error_code: 'Code de dysfonctionnement',
    jam_location: 'Localisation de la congestion',
    device_time: 'Temps',
    machine_name: 'Machine',
    paperJamsList_title: 'Liste des bourrages papier',
    error_support: 'Solution',
    error_describe: 'Détail de l\'erreur',
    serviceCallList_title: 'Liste des appels de service',
    tray: 'Bac d\'entrée',
    paperEmptyList_title: 'Liste des avis de vacance sur papier',
    output_tray_name: 'Bac de sortie',
    trayFullList_title: 'Liste Bac plein Messages',
    tonerEmptyList_title: 'Liste des messages de toner vide',
    toner_color: 'Couleur du toner',
    errorCount_tip: 'La liste a été suspendue en raison d\'une restriction d\'analyse ou de nombre.',
    solve_time: 'temps de résolution',
    change_language: 'Changement langue',
    machine_tab: 'Base',
    custom_group_tab: 'personnalisé',
    group_name: 'nom du groupe',
    group_checkbox_tip: 'Le groupe coché sera sélectionnable sur l\'interface utilisateur.',
    group_edit_tip: 'Vous pouvez ajouter un ensemble personnalisé d\'affichage de la machine.',
    custom_group: 'nom de groupe défini par l\'utilisateur',
    group_comment: 'Kommentiere',
    machine_checkbox_tip: 'La machine vérifiée s\'affiche lorsque le groupe est sélectionné.',
    group_name_exits: 'Le nom de groupe spécifié existe déjà.',
    header_group_name_max_length: 'Veuillez saisir 64 caractères ou moins.',
    header_group_name_min_length: 'Veuillez saisir le nom du groupe.',
    header_group_comment_max_length: 'Veuillez saisir 128 caractères ou moins.',
    header_device_group_switch: 'Groupe de dispositifs :',
    header_group_all: 'Tous(fogli)',
    header_group_color: 'Couleur',
    header_group_monochrome: 'noir et blanc ',
    header_group_detail_length: 'Au moins une machine doit être sélectionnée dans le groupe personnalisé.',
    header_group_select_tip: 'Il n\'y a pas de machine dans le groupe sélectionné. Enregistrez la machine dans le groupe.',
    group_name_specialchar_tip: 'Le caractère spécial @ ne peut pas être saisi',
    change_date_heading_week: 'Sélecteur de semaine',
    machine_time_line: 'ligne du temps',
    header_group_ppall: 'AccurioPress/Print',
    header_group_km1: 'AccurioJet',
    top_manager_otherTransporterror_count: 'Autre erreur de transport',
    otherTransportErrorList_title: 'Liste des autres erreurs de transport',
    jobdetail_otherTransporterror: 'Autre erreur de transport',
    top_operator_otherTransporterror: 'Autre erreur de transport',
    errCode_10008: 'La clé est erronée ou périmée.',
    feeder: 'Alimentation',
    license_expired_message: 'Votre licence est expirée',
    logout_dialog_msg: 'Toutes les fonctionnalités ne peuvent pas être utilisées tant que la licence n\'est pas valide. ',
    header_logout_yes: 'se déconnecter',
    header_logout_no: 'Annuler',
    paper_weight: 'grammage du papier',
    paper_thickness: 'Epaisseur',
    errCode_10009: 'Le SN n\'est pas enregistré.',
    errCode_10010: 'Connexion requise',
    errCode_10011: 'Aucun dispositif enregistré',
    ce_reset_password_dialog_title: 'Notification d\'informations sur le compte client',
    ce_reset_password_dialog_ultimate: 'Réinitialiser Op-Analysis',
    ce_reset_password_dialog_job_manager: 'Réinitialiser JobManager',
    ce_reset_password_dialog_all: 'Réinitialiser les deux',
    customer_email_text_job_manager: 'Cher {email},%0D%0A%0D%0A\
Nous avons créé votre compte pour AccurioPro Dashboard JobManager.%0D%0APlease log in to the URL below.%0D%0A\
URL : https://dashboard-jm.konicaminolta.com%0D%0A\
Nom d\'utilisateur : {userId}%0D%0A\
ID de l\'opérateur : administrator%0D%0A\
password: {password}%0D%0A%0D%0A\
Vous pouvez utiliser toutes les fonctions de cette application après avoir saisi la clé de produit dans la fonction de configuration de la licence. %0D%0A\
*La clé de produit vous sera envoyée par e-mail séparément. Veuillez vous en assurer.%0D%0A%0D%0A\
Cordialement, %0D%0AKonica Minolta Inc.',
    customer_email_text_all: 'Cher {email},%0D%0A%0D%0A\
Nous avons créé votre compte pour Printer Performance Analysis tool et AccurioPro Dashboard JobManager.%0D%0APour vous connecter à l\'URL ci-dessous.%0D%0A\
URL: https://dashboard-u.konicaminolta.com%0D%0A\
Nom d\'utilisateur : {ultimateUserId}%0D%0A\
Identifiant de l\'opérateur : administrator%0D%0A\
Mot de passe Op-Analysis : {ultimatePassword}%0D%0A\
Mot de passe du JobManager : {jobManagerPassword}%0D%0A%0D%0A\
Vous pouvez utiliser toutes les fonctions de cette application après avoir saisi la clé de produit dans la fonction de configuration de la licence.%0D%0A\
*La clé de produit vous sera envoyée par e-mail séparément. Veuillez vous en assurer.%0D%0A%0D%0A\
Cordialement, %0D%0AKonica Minolta Inc.',
    TZ_0000: 'Europe/West/GB, PT (+0)',
    TZ_0100: 'Europe/Central/FR, DE (+1)',
    TZ_0200: 'Europe/East/UA, GR (+2)',
    TZ_0300: 'Europe/East/TR, Moscow (+3)',
    TZ_0630: 'Asia/India (+5.5)',
    TZ_0700: 'Asia/Viet Nam (+7)',
    TZ_0800: 'Asia/China (+8)',
    TZ_0900: 'Asia/Japan, Korea (+9)',
    TZ_1400: 'Pacific/Hawaii (-10)',
    TZ_1500: 'America/Alaska (-9)',
    TZ_1600: 'America/West/Los Angeles (-8)',
    TZ_1700: 'America/Mountain/Denver (-7)',
    TZ_1800: 'America/Central/Chicago (-6)',
    TZ_1900: 'America/East/New York (-5)',
    TZ_2100: 'South America/Sao Paulo (-3)',
    time_zone_title: 'fuseau horaire',
    local_time: 'Heure locale',
    header_user_id: 'Nom de l\'utilisateur',
    ce_customers_list_title: 'Liste des clients',
    ultimate_license_expires_on: 'Op-Analysis (date d\'expiration)',
    jm_license_expires_on: 'Job Manager (date d\'expiration)',
    ce_customers_list_search: 'recherche',
    ce_edit_registered: 'enregistré',
    ce_edit_serialNumber: 'Numéro de série (machine à imprimer)',
    ce_edit_lastUpdatedDate: 'Date de la dernière mise à jour',
    ce_edit_responsibleCE: 'Ingénieur client responsable',
    ce_edit_customerInfo: 'Informations sur les clients',
    ce_edit_utimate: 'Op-Analysis',
    ce_edit_addSerialNumber: 'Ajouter un numéro de série',
    ce_edit_jobManager: 'Job Manager',
    ce_edit_commonInfo: 'Informations communes',
    ce_header_editCustomers: 'Modifier le client',
    ce_add_addCustomers_title: 'Vous pouvez ajouter un nouveau compte client',
    ce_serial_number_list: 'Numéro de série',
    ce_essential_link_file: 'Essential Linked file',
    ce_location_on_off: 'Beta features on / off',
    date: 'Date',
    before_suggistion: 'Original suggestion text',
    after_suggestion: 'Suggestion to be updated',
    batch_edit: 'Bulk update',
    data_error: 'The data has been updated. Please refresh and save again.',
    edit_suggestion: 'Edit Suggestion',
    suggestion: 'Suggestion',
    user_suggestion_list: 'Suggestion list',
    delete_suggestion: 'Delete',
    top_operator_adjustment: 'Maintenance',
    color: 'Color',
    monochrome: 'Mono',
    duplex: 'double face',
    simplex: 'simple face',
    undefined_paper: 'Aucun',
    normal_paper: 'Papier normal',
    colored_paper: 'Papier couleur',
    high_quality_paper: 'Papier de qualité supérieure',
    color_paper: 'Laser couleur',
    coated_gloss_laser_paper: 'Papier laser couché-G',
    coated_mat_laser_paper: 'Papier laser couché-M',
    coated_gloss_offset_paper: 'Papier offset couché-G',
    coated_mat_offset_paper: 'Papier offset couché-M',
    embossing_paper: 'Papier gaufré',
    envelope: 'Enveloppe',
    rough_paper: 'Papier rude',
    book_paper: 'Livre',
    coated_paper: 'Papier couché',
    preprinted_paper: 'Papier pré-imprimé',
    blank_insert_paper: 'Papier intercalaire vierge',
    generate_suggestion: 'Automated suggestion',
    error_Duration: 'Error Duration',
    jobdetail_processing_time: 'Processing Time',
    job_start_time: 'Heure de début',
    job_end_time: 'heure de fin',
    add_customer_user_id: 'User name (for Customer login)',
    add_customer_email_address: 'Customer contact e-mail address',
    change_date_heading_day: 'Date selector',
    no_log: 'Dashboard Op-Analysis logs are not sent to CSRA/CSRC',
    unused_log: 'Dashboard Op-Analysis logs are not included in CSRA/CSRC logs',
    datetime_format: 'DD.MM.YY HH:mm:ss',
    header_jobs: 'Jobs',
    no_rows_label: 'Données non disponibles',
    date_format3: 'DD.MM HH:mm',
    aqa_main_reason_fd_k: 'Vertical streak K',
    aqa_main_reason_fd_c: 'Vertical streak C',
    aqa_main_reason_fd_m: 'Vertical streak M',
    aqa_main_reason_fd_y: 'Vertical streak Y',
    aqa_main_reason_cd_k: 'Horizontal streak K',
    aqa_main_reason_cd_c: 'Horizontal streak C',
    aqa_main_reason_cd_m: 'Horizontal streak M',
    aqa_main_reason_cd_y: 'Horizontal streak Y',
    aqa_main_reason_dba_k: 'Uneven density K',
    aqa_main_reason_dba_c: 'Uneven density C',
    aqa_main_reason_dba_m: 'Uneven density M',
    aqa_main_reason_dba_y: 'Uneven density Y',
    aqa_main_reason_spot_k: 'Spot K',
    aqa_main_reason_spot_c: 'Spot C',
    aqa_main_reason_spot_m: 'Spot M',
    aqa_main_reason_spot_y: 'Spot Y',
    aqa_main_reason_backside_stain: 'Stain',
    machine_detail_timeline: 'Machine Detail Timeline',
    machine_detail_score_transition: 'Image total score transition',
    machine_detail_score_details: 'Diagnostic score details',
    machine_detail_diagnostic_history: 'DIAGNOSTIC HISTORY (Simple/Detailed)',
    machine_detail_dba_history: 'Maximum density transition',
    aqa_score_trend: 'Score',
    aqa_score_average_28days_trend: 'Trend (28 days average)',
    day_time: 'Date time',
    machine_id: 'MachineID',
    overall_score: 'Overall Score',
    main_factors: 'Main factors',
    machine_detail_score: 'Comprehensive image score',
    machine_detail_score_last_date: 'Latest date',
    machine_detail_score_last_num: 'Latest score',
    machine_detail_score_average_num: 'Historical average score',
    machine_detail_score_major_factor: 'Main factor',
    machine_detail_score_last: 'Latest score:',
    machine_detail_score_average_28days: '28 days average score:',
    aqa_diagnostic_score_legend_error: 'Error',
    aqa_diagnostic_score_legend_warning: 'Warning',
    aqa_diagnostic_score_legend_ok: 'OK',
    aqa_diagnostic_score_subtitle: 'Diagnostic Item',
    aqa_color: 'Color',
    aqa_fd_streak_rank: 'Vertical streak',
    aqa_cd_streak_rank: 'Horizontal streak',
    aqa_cd_banding_rank	: 'CD Banding',
    aqa_blurry_white_spot: 'White spot noise',
    aqa_blurry_color_spot: 'Color spot noise',
    aqa_white_spot: 'White speckle',
    aqa_black_spot: 'Black speckle',
    aqa_inky_backside: 'Stain',
    aqa_uneven_density: 'Uneven density',
    aqa_dba_adapt: '(Adjusted)',
    aqa_quality_information: 'Display AQA Quality Information',
    ce_sn_validation: 'Serial number should be 13 characters for KM printer',
    aqa_history_table_title: 'Image diagnosis (Simple/Detailed)',
    date_format4: 'DD.MM.YY HH:mm',
    header_group_AccurioLabel: 'AccurioLabel',
    header_group_registered_mixed_error: 'Web-fed machine can\'t be registered mixed with sheet-fed machine',
    label_machine_printed_length: 'Print length',
    label_machine_printed_length_with_unit: 'Print length(m)',
    label_machine_act_printed_length_with_unit: 'Act. Print length(m)',
    label_machine_printed_length_unit: 'm',
    label_machine_printed_length_time_unit: 'm/hour',
    label_machine_printed_length_with_unit2: 'Length/Set',
    label_machine_top_operator_subtitle_printed_length_result: 'Trend of print length',
    label_machine_top_operator_act_printed_length: 'Act. Print length',
    label_machine_screen_sheets_per_h: '#of prints(m/hour)',
    label_machine_joblist_est_hourlyunits: 'Pred. Print length(m/hour)',
    label_machine_joblist_act_hourlyunits: 'Act. Print length(m/hour)',
    header_machine_setting_remove_group_confirmation: 'Are you sure you want to remove this group "{group}"?',
    machinedetail_passed_day: '(Last 7 Days)',
    machinedetail_passed_week: '(Last 4 Weeks)',
    machinedetail_passed_month: '(Last 4 Months)',
    label_machine_waste_paper_length: 'Waste paper length',
    change_disabled_date_heading: 'Range',
    change_disabled_date_explanation: 'The duration of the CSV export',
    ce_edit_transportLog: 'Transport Log',
    ce_edit_transportLog_dialog_title: 'Transport Log Setting',
    ce_edit_transportLog_dialog_no: 'No.',
    ce_edit_transportLog_dialog_dev_env: 'Transport dev',
    ce_edit_transportLog_dialog_dev_stag: 'Transport sam',
    current_page: 'Current page:',
    total_pages: 'Total Pages:',
    ds_version_title: 'Version',
    ds_dashboard_version: 'KONICA MINOLTA AccurioPro Dashboard CE Version',
    ds_version_ds_num: '1.4.3',
    ds_version_oss: 'Disclosure of OSS information',
    ds_version_copyright: 'Copyright(C)2022',
    ds_version_companyName: 'KONICA MINOLTA.INC.',
    ds_import_cancle_btn: 'Close',
    header_settingMenu_version: 'Version',
    ce_application_sub_title: 'For Customer Engineers',
    ce_authorizer: 'Approver Email Address',
    ce_addCustomers_JMAndAQA_title: 'Both JobManager and Op-Analysis',
    ce_request_subTitle: 'Customer Info',
    ce_request_header_date: 'request date',
    ce_request_header_contents: 'contents',
    ce_header_link_request: 'request confirm',
    ce_edit_email_button: 'edit',
};
export default fr;
